/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, Text, Button, Icon } from '@components/atoms'

import { grey } from '@mui/material/colors'

interface PropsType {
	mode: 'none' | 'add' | 'update' | 'sign'
	totalPages: number
	page: number
	setPage: (page: number) => void
}

export const PdfPagenation = (props: PropsType) => {
	const { mode, totalPages, page, setPage } = props

	const isLeftButtonDisabled: boolean = page - 1 === -1
	const isRightButtonDisabled: boolean = page + 1 > totalPages - 1

	const onButtonClick = (direction: 'l' | 'r') => {
		if (direction === 'l') {
			setPage(page - 1)
		} else {
			setPage(page + 1)
		}
	}

	return (
		<View css={style}>
			<View className={`pdfPagenationView ${mode === 'sign' ? 'signature' : ''}`}>
				<Button
					className="pagenationButton"
					size="small"
					color={mode === 'sign' ? 'primary' : 'inherit'}
					onClick={() => onButtonClick('l')}
					disabled={isLeftButtonDisabled}
					variant={mode === 'sign' ? 'contained' : 'text'}
					css={mode === 'sign' ? null : { background: grey[50] }}
				>
					<Icon
						name="chevron-left"
						className="actionButtonIcon"
						css={{
							color: mode === 'sign' && !isLeftButtonDisabled ? 'white' : grey[800],
							opacity: isLeftButtonDisabled ? 0.3 : 1,
						}}
					/>

					{mode === 'sign' && (
						<Text
							className="actionButtonTitle"
							css={mode === 'sign' ? { marginRight: '1.5rem' } : { margin: 0 }}
						>
							이전
						</Text>
					)}
				</Button>
				<View className="pageInfoView">
					<Text category="p2" className="pageInfo">{`페이지: ${
						page + 1
					}/${totalPages}`}</Text>
				</View>

				<Button
					className="pagenationButton"
					size="small"
					color={mode === 'sign' ? 'primary' : 'inherit'}
					onClick={() => onButtonClick('r')}
					disabled={isRightButtonDisabled}
					variant={mode === 'sign' ? 'contained' : 'text'}
					css={mode === 'sign' ? null : { background: grey[50] }}
				>
					{mode === 'sign' && (
						<Text
							className="actionButtonTitle"
							css={mode === 'sign' ? { margin: '0 0.5rem' } : { margin: 0 }}
						>
							다음
						</Text>
					)}
					<Icon
						name="chevron-right"
						className="actionButtonIcon"
						css={{
							color: mode === 'sign' && !isRightButtonDisabled ? 'white' : grey[800],
							marginLeft: '0.5rem',
							opacity: isRightButtonDisabled ? 0.3 : 1,
						}}
					/>
				</Button>
			</View>
		</View>
	)
}

const style = css({
	marginTop: 8,
	marginBottom: 8,

	'.pdfPagenationView': {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		height: '100%',
		width: 'fit-content',
		background: grey[50],
		border: '1px solid',
		borderColor: grey[300],
		borderRadius: '5px',

		'.pagenationButton': {
			height: '1.9rem',
			minWidth: '1.5rem',
			padding: '0.1rem 0.4rem',
			margin: 0,

			'.actionButtonTitle': {
				padding: 0,
				textAlign: 'center',
			},
		},

		'.pageInfoView': {
			width: 'fit-content',
			padding: '0rem 0.5rem 0rem 0.2rem',

			'.pageInfo': {
				width: 'fit-content',
				margin: '0.5rem 0rem',
				color: grey[700],
				textAlign: 'center',
				whiteSpace: 'nowrap',
			},
		},

		'&.signature': {
			position: 'absolute',
			top: '0rem',
			right: 0,
			left: 0,
			margin: 'auto',
			background: '#fff',
			border: 0,
		},
	},

	'@media (max-width:405px)': {
		'.pdfPagenationView': {
			'.pageInfoView': {
				padding: 0,

				'.pageInfo': {
					fontSize: '10px',
				},
			},
		},
	},
})
